import { render } from "./booking-cancelled-modal.vue?vue&type=template&id=c0160562"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__